import { Lightbox } from "./lightbox";


export class LightboxInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Lightbox();
    }
}
